import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import type { SalesOrderShortfall } from "./operations-shared";

interface SalesOrderOversellDialogProps {
  /** The oversell to confirm; the dialog is open while this is set. */
  shortfall: SalesOrderShortfall | null;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Lets an admin knowingly create a sell order for more miles than are available. */
export function SalesOrderOversellDialog(
  props: Readonly<SalesOrderOversellDialogProps>,
) {
  const { shortfall, onCancel, onConfirm } = props;

  return (
    <AlertDialog
      open={shortfall !== null}
      onOpenChange={(open) => {
        if (!open) {
          onCancel();
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Oversell this inventory?</AlertDialogTitle>
          <AlertDialogDescription>
            {shortfall
              ? `This sell order needs ${shortfall.requiredMiles.toLocaleString()} miles but only ${shortfall.availableMiles.toLocaleString()} are available. Creating it takes the inventory to ${(-shortfall.shortfallMiles).toLocaleString()} available miles.`
              : null}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Oversell and Create</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
